import { BASE_URL } from './common';
export class UserService {
  public async login(email: string, password: string) {
    const response = await fetch(`${BASE_URL}/login`, {
      body: JSON.stringify({ 'user': email, 'password': password }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/services/user.ts